const API_BASE = process.env.REACT_APP_API_BASE;

// Helper to handle responses and throw errors on non-OK
const handleResponse = async (res) => {
    const data = await res.json();
    if (!res.ok) {
        throw new Error(data.error || 'API error');
    }
    return data;
};

// ----------------------------------------------------
// AUTHENTICATION
// ----------------------------------------------------
export const login = async (username, password) => {
    const res = await fetch(`${API_BASE}/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
    });
    return await handleResponse(res);
};

// ----------------------------------------------------
// GAMES
// ----------------------------------------------------
export const getGames = async (token) => {
    const res = await fetch(`${API_BASE}/admin/games`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return await handleResponse(res);
};

export const addGame = async (token, packageName) => {
    const res = await fetch(`${API_BASE}/admin/games`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ packageName }),
    });
    return await handleResponse(res);
};

export const deleteGame = async (token, packageName) => {
    const res = await fetch(`${API_BASE}/admin/games/${packageName}`, {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return await handleResponse(res);
};

// ----------------------------------------------------
// MARKETS
// ----------------------------------------------------
export const getMarkets = async (token, packageName) => {
    const res = await fetch(`${API_BASE}/admin/games/${packageName}/markets`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return await handleResponse(res);
};

export const addMarket = async (token, packageName, marketName) => {
    const res = await fetch(`${API_BASE}/admin/games/${packageName}/markets`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ marketName }),
    });
    return await handleResponse(res);
};

export const deleteMarket = async (token, packageName, marketName) => {
    const res = await fetch(`${API_BASE}/admin/games/${packageName}/markets/${marketName}`, {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return await handleResponse(res);
};

// ----------------------------------------------------
// MARKET DETAILS (OLD / DEFAULT-BASED ENDPOINTS)
// ----------------------------------------------------
// These remain for backward compatibility if you want to still edit "default" region directly.
export const getMarketDetails = async (token, packageName, marketName) => {
    const res = await fetch(`${API_BASE}/admin/games/${packageName}/markets/${marketName}/details`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return await handleResponse(res);
};

export const updateMarketDetails = async (token, packageName, marketName, details) => {
    const res = await fetch(`${API_BASE}/admin/games/${packageName}/markets/${marketName}/details`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(details),
    });
    return await handleResponse(res);
};

// ----------------------------------------------------
// NEW REGION-BASED ENDPOINTS
// ----------------------------------------------------
export const getRegionsList = async (token, packageName, marketName) => {
    const res = await fetch(
        `${API_BASE}/admin/games/${packageName}/markets/${marketName}/regions`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
    return await handleResponse(res); // returns { regions: [...] }
};

export const createRegion = async (token, packageName, marketName, regionName) => {
    const res = await fetch(
        `${API_BASE}/admin/games/${packageName}/markets/${marketName}/regions`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ regionName }),
        }
    );
    return await handleResponse(res);
};

export const getRegionDetails = async (token, packageName, marketName, regionName) => {
    const res = await fetch(
        `${API_BASE}/admin/games/${packageName}/markets/${marketName}/regions/${regionName}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
    return await handleResponse(res); // returns { regionData: {...} }
};

export const updateRegion = async (token, packageName, marketName, regionName, details) => {
    const res = await fetch(
        `${API_BASE}/admin/games/${packageName}/markets/${marketName}/regions/${regionName}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(details),
        }
    );
    return await handleResponse(res);
};

export const deleteRegion = async (token, packageName, marketName, regionName) => {
    const res = await fetch(
        `${API_BASE}/admin/games/${packageName}/markets/${marketName}/regions/${regionName}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
    return await handleResponse(res);
};

// Add a new admin
export const addAdmin = async (token, adminDetails) => {
    const res = await fetch(`${API_BASE}/admin/admins/add`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(adminDetails),
    });
    return await handleResponse(res);
};

// Refresh the cache
// export const refreshCache = async (token) => {
//     const res = await fetch(`${API_BASE}/admin/admin/refresh`, {
//         method: 'POST',
//         headers: {
//             Authorization: `Bearer ${token}`,
//         },
//     });
//     return await handleResponse(res);
// };


// Fetch the list of admins
export const getAdmins = async (token) => {
    const res = await fetch(`${API_BASE}/admin/admins`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return await handleResponse(res);
};

// Delete an admin
export const deleteAdmin = async (token, username) => {
    const res = await fetch(`${API_BASE}/admin/admins/${username}`, {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return await handleResponse(res);
};